import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs, Link, Typography } from "@mui/material";

type BreadcrumbSegment = {
  id: string | null;
  label: string;
};

type Props = {
  segments: BreadcrumbSegment[];
  onNavigate: (folderId: string | null) => void;
};

export function FolderBreadcrumb({ segments, onNavigate }: Props) {
  if (segments.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Repositório
      </Typography>
    );
  }

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="caminho da pasta"
      sx={{ "& .MuiBreadcrumbs-li": { fontSize: 14 } }}
    >
      <Link
        component="button"
        underline="hover"
        color="inherit"
        onClick={() => onNavigate(null)}
        sx={{ cursor: "pointer", border: 0, background: "none", p: 0 }}
      >
        Repositório
      </Link>
      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1;

        if (isLast) {
          return (
            <Typography key={segment.id ?? segment.label} color="#1361A4" fontWeight={600}>
              {segment.label}
            </Typography>
          );
        }

        return (
          <Link
            key={segment.id ?? segment.label}
            component="button"
            underline="hover"
            color="inherit"
            onClick={() => onNavigate(segment.id)}
            sx={{ cursor: "pointer", border: 0, background: "none", p: 0 }}
          >
            {segment.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
